export default function () {
	const debug = false;

	const formContainers = document.querySelectorAll('.js-home-hero-form');

	formContainers.forEach(container => {
		const div = document.createElement('div');
		div.classList.add('homepage-hero__search-form');

		while (container.firstChild) {
			div.appendChild(container.firstChild);
		}
		container.appendChild(div);

		const submitBtn = div.querySelector('.js-home-hero-submit');
		if (submitBtn) {
			submitBtn.addEventListener('click', () => {
				// Scroll to top immediately
				window.scrollTo(0, 0);

				const trigger = document.getElementById('js-header-search-toggle');
				const fauxToggle = document.getElementById('fauxToggle');
				const input2 = document.getElementById('search-window-input-2');

				if (!trigger) {
					if (debug) console.warn('Search toggle not found');
					return;
				}

				// Open search window if not already open
				if (!trigger.classList.contains('--is-active')) {
					trigger.click();
				}

				// Click fauxToggle
				if (fauxToggle) {
					fauxToggle.click();
				} else if (debug) {
					console.warn('fauxToggle not found');
				}

				// Set static "Resources Only" into the second input
				if (input2) {
					input2.value = '';
					input2.focus();
				} else if (debug) {
					console.warn('search-window-input-2 not found');
				}

				if (debug) {
					console.log('Inserted "Resources Only" into #search-window-input-2');
				}
			});
		} else if (debug) {
			console.warn('Submit button not found inside div.');
		}
	});
}
